import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { setupI18n } from './locales/index.js'
import App from './App.vue'
import router from './router'
import Vant from 'vant'
import { ConfigProvider } from 'vant'
import { Icon } from 'vant'
import 'vant/lib/index.css'
import { useTradeStore } from '@/store/trade/index'
import { _initCoinWebSocket } from '@/plugin/socket/index.js'
import { useMainStore } from '@/store/index.js'
import CmImg from './components/cm-img/index.vue'
import TopBar from './components/topBar/index.vue'
import NoData from './components/noData/index.vue'
import { storageDict } from '@/config/dict'
/**
 * 初始化socket
 */
_initCoinWebSocket()
const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
pinia.use(piniaPluginPersistedstate)
app.component('CmImg', CmImg)
app.component('TopBar', TopBar)
app.component('NoData', NoData)
app.use(router)

app.use(Vant)
app.use(ConfigProvider)
app.use(Icon)
document.addEventListener(
  'touchstart',
  function (event) {
    // 当触摸点超过1个时，你阻止了默认行为。
    // 只有在用户试图进行缩放（通常需要两个触摸点）或其他需要多点触控的操作时，才会阻止默认行为。单点触控的操作，如点击、滑动等，不会被影响。
    if (event.touches.length > 1) {
      event.preventDefault()
    }
  },
  { passive: false }
)
// 获取币种列表
const tradeStore = useTradeStore()
const mainStore = useMainStore()

// 初始化 window.__themeEnv，确保在 App.vue 使用前就有值
function initThemeEnv() {
  if (!window.__themeEnv) {
    window.__theme = import.meta.env.VITE_APP_THEME
    let themeEnv = localStorage.getItem(storageDict.THEME_ENV)
    const demo = import.meta.env.VITE_APP_DEMO
    if (demo === '1') {
      if (themeEnv == 'null' || themeEnv == null) {
        themeEnv = 'EXMINING'
      }
      localStorage.setItem(storageDict.THEME_ENV, themeEnv)
    } else {
      themeEnv = 'EXMINING'
    }
    window.__themeEnv = themeEnv || 'EXMINING'
  }
}

// 提前初始化 themeEnv，避免 App.vue 中等待
initThemeEnv()

// 初始化应用的函数
async function initApp() {
  try {
    const currentLanguage = mainStore.languageList?.filter((item) => item.isDefault === 'Y') || []
    // 判断语言列表中是否存在缓存语言 若不存在 使用默认语言
    let defaultLanguage = mainStore.language || ''
    if (!defaultLanguage && currentLanguage.length) {
      defaultLanguage = currentLanguage[0].dictValue || 'en'
    }
    const i18n = await setupI18n(defaultLanguage)
    window.__theme = import.meta.env.VITE_APP_THEME
    let themeEnv = localStorage.getItem(storageDict.THEME_ENV)
    console.log(themeEnv, 'themeEnv')
    const demo = import.meta.env.VITE_APP_DEMO
    if (demo === '1') {
      if (themeEnv == 'null' || themeEnv == null) {
        themeEnv = 'EXMINING'
      }
      localStorage.setItem(storageDict.THEME_ENV, themeEnv)
    } else {
      // themeEnv = res
      themeEnv = 'EXMINING'
    }
    window.__themeEnv = themeEnv || 'EXMINING'

    // 动态加载主题CSS
    if (themeEnv === 'YT') {
      import(`@/assets/css/YT/index.css`)
    } else if (themeEnv === 'CICC') {
      import(`@/assets/css/CICC/index.css`)
    } else if (themeEnv === 'CMBIT') {
      import(`@/assets/css/CMBIT/index.css`)
    } else if (themeEnv === 'TKBIT') {
      import(`@/assets/css/TKBIT/index.css`)
    } else if (themeEnv === 'ARKADEX') {
      import(`@/assets/css/ARKADEX/index.css`)
    } else if (themeEnv === 'EXMINING') {
      import(`@/assets/css/EXMINING/index.css`)
    }
    app.use(i18n)
    app.mount('#app')
  } catch (error) {
    console.error('应用初始化失败:', error)
    // 即使出错也要挂载应用，避免白屏
    try {
      const i18n = await setupI18n('en')
      app.use(i18n)
      app.mount('#app')
    } catch (mountError) {
      console.error('应用挂载失败:', mountError)
      // 最后的兜底方案：直接挂载
      app.mount('#app')
    }
  }
}

// 获取平台地址 获取平台配置 币种列表 语言列表
// 设置超时，避免无限等待导致白屏
const initTimeout = setTimeout(() => {
  console.warn('初始化超时，强制挂载应用')
  initApp()
}, 10000) // 10秒超时

Promise.all([
  mainStore.getPlatFormConfig().catch((err) => {
    console.error('获取平台配置失败:', err)
    return null
  }),
  mainStore.getSettingConfig().catch((err) => {
    console.error('获取设置配置失败:', err)
    return null
  }),
  tradeStore.getCoinList().catch((err) => {
    console.error('获取币种列表失败:', err)
    return null
  })
])
  .then(() => {
    clearTimeout(initTimeout)
    initApp()
  })
  .catch((error) => {
    clearTimeout(initTimeout)
    // API 请求失败时也要挂载应用，避免白屏
    console.error('初始化配置加载失败:', error)
    initApp()
  })
